export default __webpack_public_path__ + "static/media/Gauntlets of the Fallen Empire.ce7d36b4.jpg";